import { print } from 'graphql';
import { gql } from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';

export interface WorkPackageFiles {
  readonly fileId: string;
  readonly workPackageId: string;
  readonly fileName: string;
  readonly filePath: string;
  readonly inspectorId: number;
  readonly dateCreated: string;
  readonly dateModified: string;
  readonly siteId: number;
  readonly disciplineId: number;
}

export const workPackageFilesSchema: RxJsonSchema<WorkPackageFiles> = {
  type: 'object',
  version: 0,
  description: 'describes work package files',
  primaryKey: 'fileId',
  properties: {
    fileId: { type: 'string', maxLength: 36 },
    workPackageId: { type: ['string', 'null'] },
    fileName: { type: ['string', 'null'] },
    filePath: { type: ['string', 'null'] },
    inspectorId: { type: ['number', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    siteId: { type: ['number', 'null'] },
    disciplineId: { type: ['number', 'null'] },
  },
};

export type WorkPackageFilesCollection = RxCollection<WorkPackageFiles> | null;
export type WorkPackageFilesDocument = RxDocument<WorkPackageFiles>;

export const workPackageFilesPullQueryBuilder = (document: WorkPackageFiles) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query workPackageFileDetailsFeed(
      $siteId: Int!
      $disciplineId: Int!
      $lastModified: DateTime!
      $isLeadInspector: Boolean!
    ) {
      workPackageFileDetailsFeed(
        siteId: $siteId
        disciplineId: $disciplineId
        lastModified: $lastModified
        isLeadInspector: $isLeadInspector
      ) {
        fileId
        workPackageId
        fileName
        filePath
        inspectorId
        siteId
        disciplineId
        dateCreated
        dateModified
      }
    }
  `);
  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastModified: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc.siteId,
        doc.disciplineId,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
      isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
    },
  };
};

export const workPackageFilesPullModifier = (doc: WorkPackageFiles) => {
  const result = {
    ...doc,
  };
  if (
    result?.siteId === 0 ||
    result?.disciplineId === 0 ||
    result?.siteId === null ||
    result?.disciplineId === null ||
    result?.siteId !==
      Number(JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId) ||
    result?.disciplineId !==
      Number(JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId)
  ) {
    result.siteId = Number(JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId);
    result.disciplineId = Number(
      JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
    );
  }
  return result;
};

export default {};
